export const toImageDataUrl = (imageData) => {
    if (!imageData?.data) return null;

    try {
        if (typeof imageData.data === 'string') {
            return `data:image/jpeg;base64,${imageData.data}`;
        }

        const bytes = new Uint8Array(imageData.data);
        const chunkSize = 4096;
        let binary = '';

        for (let i = 0; i < bytes.byteLength; i += chunkSize) {
            const chunk = bytes.slice(i, Math.min(i + chunkSize, bytes.byteLength));
            binary += String.fromCharCode.apply(null, chunk);
        }

        return `data:image/jpeg;base64,${btoa(binary)}`;
    } catch (err) {
        console.log('Failed to process image data');
        return null;
    }
};

export const toImageObjectUrl = (imageData) => {
    if (!imageData?.data) return null;

    try {
        if (typeof imageData.data === 'string') {
            return `data:image/jpeg;base64,${imageData.data}`;
        }

        const bytes = new Uint8Array(imageData.data);
        return URL.createObjectURL(new Blob([bytes], { type: 'image/jpeg' }));
    } catch (err) {
        console.log('Failed to process image data');
        return null;
    }
};

export const revokeImageUrl = (url) => {
    if (url?.startsWith('blob:')) URL.revokeObjectURL(url);
};
